import { Link } from "react-router-dom";
import type { MediaItem } from "@/mocks/media";
import { formatActors } from "@/utils/media";

interface MovieCardProps {
  item: MediaItem;
  showActors?: boolean;
}

export default function MovieCard({ item, showActors = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-all duration-300 hover:-translate-y-1 hover:border-primary-400/70"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} - ${item.category}封面`}
          title={`${item.title} - ${item.category}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 flex items-center justify-between p-3">
          <span className="rounded-full bg-background-950/75 px-2.5 py-1 text-xs font-medium text-foreground-950 backdrop-blur">
            {item.category}
          </span>
          <span className="flex items-center gap-1 rounded-full bg-accent-500/90 px-2 py-1 text-xs font-semibold text-background-50">
            <i className="ri-star-fill text-xs"></i>
            {item.rating}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/90 to-transparent p-3 pt-10">
          <p className="line-clamp-1 text-sm font-medium text-foreground-950">
            {item.genre.slice(0, 2).join(" · ")}
          </p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="line-clamp-1 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-400">
          {item.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-600">
          {showActors
            ? `主演：${formatActors(item)}`
            : `${item.year} · ${item.region}`}
        </p>
      </div>
    </Link>
  );
}